import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { NzResultComponent, NzResultExtraDirective } from 'ng-zorro-antd/result';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { environment } from '../../../../environments/environment';
import { TitleService } from '../../services/title.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NzResultComponent, NzResultExtraDirective, NzButtonComponent],
})
export class NotFoundComponent implements OnInit {
  private titleService = inject(TitleService);

  backUrl = environment.portal_url;

  ngOnInit(): void {
    this.titleService.setTitle('Page not found');
  }
}
